(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('projectAreaService', projectAreaService);

	projectAreaService.$inject = ['$http', 'URLS'];

	function projectAreaService($http, URLS) {
		var service = {
			getAreas: getAreas,
			getProjectAreas: getProjectAreas,
			saveApprovers: saveApprovers,
			saveTarget: saveTarget,
			getUsers: getUsers,
			deleteArea: deleteArea,
			addProjectArea: addProjectArea,
			updateProjectArea: updateProjectArea
		};
		return service;

		function getAreas(siteId) {
			return $http.get('/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/AreaApproversReport')
				.then(getAreaApproversSuccess, handleError);

			function getAreaApproversSuccess(response) {
				return response;
			}
		}

		function getProjectAreas(siteId) {
			var url = URLS.host + String.format(URLS.projectAreas, siteId || globalConfig.factory.id);
			return $http.get(url)
				.then(getAreasComplete)
				.catch(getAreasFailed);

			function getAreasComplete(response) {
				return response.data;
			}

			function getAreasFailed(error) {
				return [];
			}
		}

		function saveApprovers(data, siteId) {
			return $http.put('/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/AreaApprovers', data)
				.then(saveDataSuccess, handleError);

			function saveDataSuccess(response) {
				return response;
			}
		}

		function saveTarget(data, siteId) {
			return $http.put('/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/AreaTarget', data)
				.then(saveDataSuccess, handleError);

			function saveDataSuccess(response) {
				return response;
			}
		}

		function deleteArea(areaNdx, newAreaNdx, siteId) {
			var url = '/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/Area/' + areaNdx;
			if (typeof newAreaNdx !== 'undefined' && newAreaNdx > 0) {
				url = url + '?newAreaNdx=' + newAreaNdx;
			}
			return $http.delete(url)
				.then(deleteAreaSuccess, handleError);

			function deleteAreaSuccess(response) {
				return 'Project area deleted successfully';
			}
		}

		function getUsers(factoryId) {
			return $http.get('/api/2/Dimensions/factndx/' + (factoryId || globalConfig.factory.id) + '/ResponsibleUsers')
				.then(getUsersSuccess, handleError);

			function getUsersSuccess(response) {
				return response;
			}
		}

		function addProjectArea(projectArea, siteId) {
			var projectAreaCrudUrl = URLS.host + String.format(URLS.projectAreaCrud, siteId || globalConfig.factory.id);

			return $http.post(projectAreaCrudUrl, projectArea)
				.then(addProjectAreaSuccess, handleError);

			function addProjectAreaSuccess(response) {
				return 'Project area created successfully';
			}
		}

		function updateProjectArea(projectArea, siteId, lastModified) {
			var projectAreaCrudUrl = URLS.host + String.format(URLS.projectAreaCrud, siteId || globalConfig.factory.id);
			return $http.put(projectAreaCrudUrl + '/' + projectArea.ndx, projectArea, { headers: { 'If-Unmodified-Since': lastModified } })
				.then(updateProjectAreaSuccess, updateProjectAreaError);

			function updateProjectAreaSuccess(response) {
				return response;
			}

			function updateProjectAreaError(response) {
				return response;
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412 || error.status === 409) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();
